module.exports = "<p>\n  test works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/app-core/test/test.component.html
// module id = ../../../../../src/app/app-core/test/test.component.html
// module chunks = main